import React from 'react'
import {connect} from 'react-redux'
import styles from './GuidePage.scss'
import layout from '../layout.scss'
import cx from 'classnames'
import {GuidesList} from './GuidesList'
import {EditorColumn} from './EditorColumn'
import {getExperienceId} from '../ExperiencesApp/ExperiencesApp'
import {experienceActions, experienceSelectors} from 'data/resources/experiences'
import * as guidesActions from 'lib/api/experiences/guides'
import {experienceRoutesActions} from 'lib/api/experiences/routes'
import Helmet from 'react-helmet'

export class _GuidePage extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      expandedId: null
    }
  }

  componentDidMount () {
    const {loadExperience, loadGuides, loadRoutes} = this.props
    loadExperience()
    loadGuides()
    loadRoutes()
  }

  componentDidUpdate (prevProps) {
    const {loadExperience, loadGuides, loadRoutes} = this.props
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      loadExperience()
      loadGuides()
      loadRoutes()
    }
  }

  setExpanded = (id) => {
    this.setState({expandedId: id})
  }

  render () {
    const {guideIds, guides, experience} = this.props
    const {expandedId} = this.state
    const expandedGuide = expandedId ? guides.get(expandedId) : null

    return (
      <div className={cx(layout.container, styles.GuidePage)}>
        {experience && <Helmet title={experience.name} />}
        <div className={layout.mainColumn}>
          {guideIds && experience && <GuidesList
            guideIds={guideIds}
            guides={guides}
            experience={experience}
            expandedId={expandedId}
            setExpanded={this.setExpanded} />}
        </div>
        <div className={layout.editorColumn}>
          <EditorColumn guideIds={guideIds} guide={expandedGuide} />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    loadGuides: () => dispatch(guidesActions.loadGuides(experienceId)),
    loadRoutes: () => dispatch(experienceRoutesActions.loadAll(experienceId))
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)
  const gState = state.guides

  return {
    experience: experienceSelectors.find(state, experienceId),
    guideIds: gState.getIn(['experienceGuides', experienceId], []),
    guides: gState.get('guidePages')
  }
}

export const GuidePage = connect(
  mapStateToProps,
  mapDispatchToProps
)(_GuidePage)
